// fuck pannellum!
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// fuck pannellum!!
/* eslint-disable @typescript-eslint/no-unsafe-call */
// fuck pannellum!!!
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
// @ts-strict-ignore

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { ImageConfig } from '@workbench/core/dist/types/components/360-viewer/types';
import { ComponentInterface } from '@workbench/core/dist/types/stencil-public-runtime';
import { combineLatest, firstValueFrom, from, fromEvent, interval, Observable, of, timer, toArray } from 'rxjs';
import {
  concatMap,
  debounce,
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  first,
  map,
  shareReplay,
  switchMap,
  take,
  tap,
  withLatestFrom
} from 'rxjs/operators';

import { StageView, StageViewDefinition, StageViewState } from 'src/app/api/owcc/models';
import { AppDomContextService } from 'src/app/app-dom-context.service';
import { LinkService } from 'src/app/core/services/link/link.service';
import { TrackingAction } from 'src/app/core/services/tracking/models/tracking-action.enum';
import { TrackingCategory } from 'src/app/core/services/tracking/models/tracking-category.enum';
import { TrackingInput } from 'src/app/core/services/tracking/models/tracking-object.interface';
import { AppRoutePath } from 'src/app/routing/app-route-path.enum';
import { StagePerspective } from 'src/app/shared/header-info/stage-perspective.enum';
import { updateIsSummarySidebarShown } from 'src/app/store/common/common.actions';
import {
  selectFilteredPreviousRouteState,
  selectIsConfigurationStepCabrioRoof
} from 'src/app/store/router/router.selectors';
import { noop } from 'src/app/utils/functions/noop';
import { observeOnResize } from 'src/app/utils/functions/observe-on-resize';
import { filterTruthy } from 'src/app/utils/functions/rx-filters';
import { waitForElement } from 'src/app/utils/functions/wait-for-element';
import { KeyCode } from 'src/app/utils/models/key-code.enum';

import { INTERIOR_THREE_SIXTY_CANVAS_ELEMENT, INTERIOR_THREE_SIXTY_CONTAINER_ID } from '../awesome-stage.component';
import { stageParamsToQueryParams } from '../awesome-stage.helpers';
import {
  InteriorParameter,
  RoofStateValue,
  StageBaseData,
  StageConfig,
  StageUpdateData,
  StageViewStateValue,
  type StageRatio
} from '../awesome-stage.model';
import { BbdUrlBuilder } from '../bbd-url-builder';
import imagePreloadScheduler, { RotationDirection } from '../image-preload-scheduler';
import interiorImagePreloader from '../image-preloader';

import { AwesomeStageCommonStore, AwesomeStageState } from './awesome-stage-common.store';
import {
  AMOUNT_OF_INTERIOR_THREE_SIXTY_IMAGES,
  CHECK_EXTERIOR_IMAGE_STATE_INTERVAL,
  IMAGE_LOADER_SPINNER_DEBOUNCE,
  INTERIOR_THREE_SIXTY,
  INTERIOR_THREE_SIXTY_INDEX_ORDER,
  INTERIOR_THREESIXTY_IMAGE_WIDTH_MAP,
  INTERIOR_TRUNK_PERSPECTIVE,
  PANNELLUM_CLASS_SELECTOR_ABOUT_MSG,
  PANNELLUM_CLASS_SELECTOR_LOAD_BOX,
  toStatesPerScreenMode
} from './awesome-stage-store-constants';
import { Icon, ScreenMode, ThreeSixtyInteriorDataUpdateState, TrackingId } from './awesome-stage.store.enum';
import { ImageParameters } from './image-parameters.interface';
import { StatePerScreenMode } from './state-per-screen-mode';
import { ThreeSixtyInteriorData } from './three-sixty-interior-data';

// Unfortunately, the pannellum library does not provide typings
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PannellumViewer = any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let pannellum: any;

interface AnimationSlowdownMap {
  [key: number]: number;
  default: number;
}

export type Milliseconds = number;
// extended type to add the dominated rooftop state to the stageupdate data type, used for the roof top user choice decision
export type StageUpdateDataExtended = StageUpdateData & { dominatedRooftopState: RoofStateValue };

// copied from workbench definition (as its not exported)
export interface SliderComponent extends ComponentInterface, HTMLElement {
  /** scrolls to the slider item at the given index (starts at 0) */
  scrollToIndex(index: number, behavior?: 'smooth' | 'auto'): Promise<void>;
}

// view toggle image width needs to be double the img tag width (retina display)
const VIEW_TOGGLE_IMG_WIDTH = 400;

@Injectable()
export class AwesomeStageStore extends AwesomeStageCommonStore {
  public readonly hasInteriorView$ = this.select(
    this.stageBaseData$,
    stageBaseData => !!stageBaseData?.metaData?.views?.[StageView.Interior]
  );

  public readonly hasInteriorThreeSixtyView$ = this.select(
    this.stageMetaData$,
    stageMetaData => !!stageMetaData?.views?.[StageView.Interior360]
  );

  public readonly isInThreeSixtyInteriorMode$ = this.select(this.state$, state => state.isInThreeSixtyInteriorMode);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  public readonly pannellumViewer$ = this.select(this.state$, state => state.pannellumViewer);

  public readonly isExteriorThreeSixtyStageLoaded$ = this.select(
    this.state$,
    state => state.isExteriorThreeSixtyStageLoaded
  );

  public readonly isInteriorView$: Observable<boolean> = this.select(
    this.currentView$,
    view => view === StageView.Interior
  );

  public readonly isInteriorThreeSixtyView$: Observable<boolean> = this.select(
    this.currentView$,
    view => view === StageView.Interior360
  );

  /**
   * @returns true if interior view (with images) or 360 interior view is active
   */
  public readonly isAnyInteriorView$ = this.select(
    this.isInteriorView$,
    this.isInteriorThreeSixtyView$,
    (interiorView, threeSixtyInteriorView) => interiorView || threeSixtyInteriorView
  );

  public readonly invertedView$: Observable<StageView> = this.select(
    this.isAnyInteriorView$,
    this.isInThreeSixtyInteriorMode$,
    (isAnyInteriorView, isThreeSixtyInteriorView) => {
      if (isAnyInteriorView) {
        return StageView.Exterior360;
      }

      return isThreeSixtyInteriorView ? StageView.Interior360 : StageView.Interior;
    }
  );

  public readonly exteriorViewDefinition$ = this.select(
    this.stageMetaData$,
    stageMetaData => stageMetaData?.views?.[StageView.Exterior360]
  );

  public readonly interiorViewDefinition$ = this.select(
    this.stageMetaData$,
    stageMetaData => stageMetaData?.views?.[StageView.Interior]
  );

  public readonly interiorThreeSixtyViewDefinition$ = this.select(
    this.stageMetaData$,
    stageMetaData => stageMetaData?.views?.[StageView.Interior360]
  );

  public readonly interiorPerspectives$ = this.select(
    this.interiorViewDefinition$,
    interiorViewDefinition => interiorViewDefinition?.perspectives
  );

  public readonly exteriorStageViewState$ = this.select(state => state.exteriorStageViewState);

  public readonly exteriorStageViewStateByScreenMode$ = this.select(
    this.exteriorStageViewState$,
    this.isInFullscreenMode$,
    (stageViewState, isInFullscreenMode) => stageViewState?.getStateByScreenModeFlag(isInFullscreenMode)
  );

  public readonly interiorStageViewState$ = this.select(state => state.interiorStageViewState);

  public readonly interiorStageViewStateByScreenMode$ = this.select(
    this.interiorStageViewState$,
    this.isInFullscreenMode$,
    (stageViewState, isInFullscreenMode) => stageViewState?.getStateByScreenModeFlag(isInFullscreenMode)
  );

  public readonly interiorThreeSixtyStageViewState$ = this.select(state => state.interiorThreeSixtyStageViewState);

  public readonly interiorThreeSixtyStageViewStateByScreenMode$ = this.select(
    this.interiorThreeSixtyStageViewState$,
    this.isInFullscreenMode$,
    (stageViewState, isInFullscreenMode) => stageViewState?.getStateByScreenModeFlag(isInFullscreenMode)
  );

  public readonly exteriorStageStatesByScreenMode$: Observable<StatePerScreenMode<StageViewState[]>> = this.select(
    this.exteriorViewDefinition$,
    viewDefinition => toStatesPerScreenMode(viewDefinition?.states, viewDefinition?.fullScreenDefinition?.states)
  );

  public readonly interiorStageStatesByScreenMode$: Observable<StatePerScreenMode<StageViewState[]>> = this.select(
    this.interiorViewDefinition$,
    viewDefinition => toStatesPerScreenMode(viewDefinition?.states, viewDefinition?.fullScreenDefinition?.states)
  );

  public readonly interiorThreeSixtyStageStatesByScreenMode$: Observable<StatePerScreenMode<StageViewState[]>> =
    this.select(this.interiorThreeSixtyViewDefinition$, viewDefinition =>
      toStatesPerScreenMode(viewDefinition?.states, viewDefinition?.fullScreenDefinition?.states)
    );

  public readonly exteriorStageViewStateToggleOffered$: Observable<StatePerScreenMode<boolean>> = this.select(
    this.exteriorStageStatesByScreenMode$,
    stageStates =>
      new StatePerScreenMode<boolean>(
        this.isDayAndNightStageViewStateAvailable(stageStates.nonFullscreen),
        this.isDayAndNightStageViewStateAvailable(stageStates.fullscreen)
      )
  );

  public readonly exteriorRoofStateByScreenMode$ = this.select(
    this.exteriorRoofState$,
    this.isInFullscreenMode$,
    (roofState, isInFullscreenMode) => roofState?.getStateByScreenModeFlag(isInFullscreenMode)
  );

  public readonly exteriorRoofStateToggleOffered$: Observable<StatePerScreenMode<boolean>> = this.select(
    this.exteriorStageStatesByScreenMode$,
    roofState =>
      new StatePerScreenMode<boolean>(
        this.isOpenedAndClosedRoofStateAvailable(roofState.nonFullscreen),
        this.isOpenedAndClosedRoofStateAvailable(roofState.fullscreen)
      )
  );

  public readonly stageViewStateChange$: Observable<StageViewStateValue> = this.select(
    this.currentView$,
    this.exteriorStageViewStateByScreenMode$,
    this.interiorStageViewStateByScreenMode$,
    this.interiorThreeSixtyStageViewStateByScreenMode$,
    (currentView, exteriorStageViewState, interiorStageViewState, interiorThreeSixtyStageViewState) =>
      this.viewHandler<StageViewStateValue>(
        currentView,
        () => exteriorStageViewState,
        () => interiorStageViewState,
        () => interiorThreeSixtyStageViewState
      )
  );

  public readonly interiorRoofStateByScreenMode$ = this.select(
    this.interiorRoofState$,
    this.isInFullscreenMode$,
    (roofState, isInFullscreenMode) => roofState?.getStateByScreenModeFlag(isInFullscreenMode)
  );

  public readonly interiorThreeSixtyRoofStateByScreenMode$ = this.select(
    this.interiorThreeSixtyRoofState$,
    this.isInFullscreenMode$,
    (roofState, isInFullscreenMode) => roofState?.getStateByScreenModeFlag(isInFullscreenMode)
  );

  public readonly roofStateChange$: Observable<RoofStateValue> = this.select(
    this.currentView$,
    this.exteriorRoofStateByScreenMode$,
    this.interiorRoofStateByScreenMode$,
    this.interiorThreeSixtyRoofStateByScreenMode$,
    (currentView, exteriorRoofState, interiorRoofState, interiorThreeSixtyRoofState) =>
      this.viewHandler<RoofStateValue>(
        currentView,
        () => exteriorRoofState,
        () => interiorRoofState,
        () => interiorThreeSixtyRoofState
      )
  );

  public readonly interiorStageViewStateToggleOffered$: Observable<StatePerScreenMode<boolean>> = this.select(
    this.interiorStageStatesByScreenMode$,
    stageStates =>
      new StatePerScreenMode<boolean>(
        this.isDayAndNightStageViewStateAvailable(stageStates.nonFullscreen),
        this.isDayAndNightStageViewStateAvailable(stageStates.fullscreen)
      )
  );

  public readonly interiorThreeSixtyStageViewStateToggleOffered$: Observable<StatePerScreenMode<boolean>> = this.select(
    this.interiorThreeSixtyStageStatesByScreenMode$,
    stageStates =>
      new StatePerScreenMode<boolean>(
        this.isDayAndNightStageViewStateAvailable(stageStates.nonFullscreen),
        this.isDayAndNightStageViewStateAvailable(stageStates.fullscreen)
      )
  );

  public readonly interiorRoofStateToggleOffered$: Observable<StatePerScreenMode<boolean>> = this.select(
    this.interiorStageStatesByScreenMode$,
    roofState =>
      new StatePerScreenMode<boolean>(
        this.isOpenedAndClosedRoofStateAvailable(roofState.nonFullscreen),
        this.isOpenedAndClosedRoofStateAvailable(roofState.fullscreen)
      )
  );

  public readonly interiorThreeSixtyRoofStateToggleOffered$: Observable<StatePerScreenMode<boolean>> = this.select(
    this.interiorThreeSixtyStageStatesByScreenMode$,
    roofState =>
      new StatePerScreenMode<boolean>(
        this.isOpenedAndClosedRoofStateAvailable(roofState.nonFullscreen),
        this.isOpenedAndClosedRoofStateAvailable(roofState.fullscreen)
      )
  );

  /**
   * @returns true if
   * - is in interior view and interior 360 view definition is available
   * - is in interior 360 view and interior view definition is available
   *
   * false otherwise
   */
  public readonly isOppositeInteriorViewDefinitionAvailable$ = this.select(
    this.isInteriorView$,
    this.isInteriorThreeSixtyView$,
    this.hasInteriorView$,
    this.hasInteriorThreeSixtyView$,
    (isInteriorView, isInteriorThreeSixtyView, hasInteriorView, hasInteriorThreeSixtyView) =>
      (isInteriorView && hasInteriorThreeSixtyView) || (isInteriorThreeSixtyView && hasInteriorView)
  );

  public readonly threeSixtyChangeForCurrentViewOffered$ = this.select(
    this.isAnyInteriorView$,
    this.isOppositeInteriorViewDefinitionAvailable$,
    this.isInteriorThreeSixtyError$,
    (isAnyInteriorView, isOppositeInteriorViewDefinitionAvailable, isInteriorThreeSixtyError) =>
      isAnyInteriorView && isOppositeInteriorViewDefinitionAvailable && !isInteriorThreeSixtyError
  );

  public readonly interiorThreeSixtyStateIcon$ = this.select(
    this.isInThreeSixtyInteriorMode$,
    isInThreeSixtyInteriorMode => (isInThreeSixtyInteriorMode ? Icon.Camera : Icon.ThreeSixty)
  );

  public readonly interiorThreeSixtyPerspectives$ = this.select(
    this.interiorThreeSixtyViewDefinition$,
    interiorThreeSixtyViewDefinition => interiorThreeSixtyViewDefinition?.perspectives
  );

  public readonly interiorThreeSixtyImageWidthByMq$: Observable<number> = this.select(
    this.mediaQuery$,
    mediaQuery => INTERIOR_THREESIXTY_IMAGE_WIDTH_MAP[mediaQuery] || INTERIOR_THREESIXTY_IMAGE_WIDTH_MAP.default
  );

  public readonly exteriorPerspectives$ = this.select(
    this.exteriorViewDefinition$,
    exteriorViewDefinition => exteriorViewDefinition?.perspectives || []
  );

  public readonly interiorThreeSixtyImageParameters$: Observable<ImageParameters> = this.select(
    this.stageBaseData$,
    this.baseInfo$,
    this.interiorThreeSixtyPerspectives$,
    this.interiorThreeSixtyStageViewStateByScreenMode$,
    this.interiorThreeSixtyRoofStateByScreenMode$,
    this.interiorThreeSixtyViewDefinition$,
    this.isInFullscreenMode$,
    this.interiorThreeSixtyImageWidthByMq$,
    (
      stageBaseData,
      baseInfo,
      perspectives,
      stageViewState,
      roofState,
      interiorThreeSixtyViewDefinition,
      isInFullscreenMode,
      interiorThreeSixtyImageWidth
    ) =>
      this.buildImageParameters(
        interiorThreeSixtyViewDefinition,
        stageBaseData,
        baseInfo,
        perspectives,
        stageViewState,
        roofState,
        isInFullscreenMode,
        interiorThreeSixtyImageWidth
      )
  );

  public readonly exteriorImageParameters$: Observable<ImageParameters> = this.select(
    this.stageBaseData$,
    this.baseInfo$,
    this.exteriorPerspectives$,
    this.exteriorStageViewStateByScreenMode$,
    this.exteriorRoofStateByScreenMode$,
    this.exteriorViewDefinition$,
    this.isInFullscreenMode$,
    this.imageWidthByMq$,
    (
      stageBaseData,
      baseInfo,
      perspectives,
      stageViewState,
      roofState,
      exteriorViewDefinition,
      isInFullscreenMode,
      imageWidth
    ) =>
      this.buildImageParameters(
        exteriorViewDefinition,
        stageBaseData,
        baseInfo,
        perspectives,
        stageViewState,
        roofState,
        isInFullscreenMode,
        imageWidth
      )
  );

  public readonly interiorThreeSixtyTextureUrls$: Observable<string[]> = this.select(
    this.interiorThreeSixtyImageParameters$,
    this.currentView$,
    (interiorThreeSixtyImageParameters, currentView) => {
      // we don't return urls if user is not in interior 360 mode.
      // if we returned urls and user later on again switches to 360 mode the "full history" of the latest selection changes would be visible
      if (currentView !== StageView.Interior360 || interiorThreeSixtyImageParameters.hasImageError) {
        return [];
      }

      return INTERIOR_THREE_SIXTY_INDEX_ORDER.reduce((array: string[], index: number) => {
        const perspective = interiorThreeSixtyImageParameters?.perspectives?.[index];
        return [
          ...array,
          this.createImgSrc(
            interiorThreeSixtyImageParameters.cosyId,
            interiorThreeSixtyImageParameters.hasImageError,
            interiorThreeSixtyImageParameters.baseInfo,
            interiorThreeSixtyImageParameters.imgType,
            perspective,
            interiorThreeSixtyImageParameters.stageViewState,
            interiorThreeSixtyImageParameters.roofState,
            interiorThreeSixtyImageParameters.additionalParameters,
            interiorThreeSixtyImageParameters.imageWidth
          )
        ];
      }, []);
    }
  );

  public readonly interiorThreeSixtyLastState$ = this.select(state => state.interiorThreeSixtyLastState);

  public readonly interiorSliderIndex$ = this.select(state => state.interiorSliderIndex);

  public readonly interiorParameterChange$ = this.select(
    this.interiorStageViewStateByScreenMode$,
    this.interiorRoofStateByScreenMode$,
    this.interiorSliderIndex$,
    this.currentView$,
    (interiorStageViewStateByScreenMode, interiorRoofStateByScreenMode, interiorSliderIndex, currentView) =>
      ({
        stageViewState: interiorStageViewStateByScreenMode,
        roofState: interiorRoofStateByScreenMode,
        sliderIndex: interiorSliderIndex,
        isInterior: currentView === StageView.Interior
      }) as InteriorParameter
  );

  public readonly interior360DataUrl$ = this.select(
    this.isInScreenMirroringMode$,
    this.interiorThreeSixtyLastState$,
    (isInScreenMirroringMode, interiorThreeSixtyLastState) => ({
      isInScreenMirroringMode,
      interiorThreeSixtyLastState
    })
  ).pipe(
    filter(
      ({ isInScreenMirroringMode, interiorThreeSixtyLastState }) =>
        isInScreenMirroringMode &&
        interiorThreeSixtyLastState?.updatedBy === ThreeSixtyInteriorDataUpdateState.AnimateFinished
    ),
    // TODO: Fix with MBCC-2538
    // eslint-disable-next-line @ngrx/avoid-mapping-component-store-selectors
    map(() => this.appDomContext.shadowRoot?.querySelector(INTERIOR_THREE_SIXTY_CANVAS_ELEMENT)),
    filter(canvas => !!canvas),
    // TODO: Fix with MBCC-2538
    // eslint-disable-next-line @ngrx/avoid-mapping-component-store-selectors
    map(canvas => canvas.toDataURL('image/webp'))
  );

  public readonly stageViewStateIcon$ = this.select(
    this.currentView$,
    this.exteriorStageViewStateByScreenMode$,
    this.interiorStageViewStateByScreenMode$,
    this.interiorThreeSixtyStageViewStateByScreenMode$,
    (currentView, exteriorStageViewState, interiorStageViewState, interiorThreeSixtyStageViewState) => {
      const iconByStageViewState = (stageViewState: StageViewStateValue): Icon =>
        stageViewState === StageViewStateValue.Day ? Icon.LightOff : Icon.LightOn;
      return this.viewHandler<Icon>(
        currentView,
        () => iconByStageViewState(exteriorStageViewState),
        () => iconByStageViewState(interiorStageViewState),
        () => iconByStageViewState(interiorThreeSixtyStageViewState)
      );
    }
  );

  public readonly exteriorThreeSixtyIndicatorTheme$: Observable<'light' | 'dark'> = this.select(
    this.exteriorStageViewState$,
    exteriorStageViewState =>
      exteriorStageViewState.getStateByScreenMode(ScreenMode.NonFullscreen) === StageViewStateValue.Day
        ? 'light'
        : 'dark'
  );

  public readonly interiorThreeSixtyStateButtonTooltip$: Observable<string | undefined> = this.select(
    this.currentView$,
    this.buttonTooltipTexts$,
    (currentView, buttonTooltipTexts): string | undefined => {
      if (currentView === StageView.Interior) {
        return buttonTooltipTexts.turnThreeSixtyOn;
      }
      if (currentView === StageView.Interior360) {
        return buttonTooltipTexts.turnThreeSixtyOff;
      }
      return undefined;
    }
  );

  public readonly roofStateButtonTooltip$: Observable<string> = this.select(
    this.currentView$,
    this.exteriorRoofStateByScreenMode$,
    this.interiorRoofStateByScreenMode$,
    this.interiorThreeSixtyRoofStateByScreenMode$,
    this.buttonTooltipTexts$,
    (currentView, exteriorRoofState, interiorRoofState, interiorThreeSixtyRoofState, buttonTooltipTexts) => {
      const tooltipTextByRoofState = (roofState: RoofStateValue): string =>
        roofState === RoofStateValue.Opened ? buttonTooltipTexts.closeRoof : buttonTooltipTexts.openRoof;

      return this.viewHandler<string>(
        currentView,
        () => tooltipTextByRoofState(exteriorRoofState),
        () => tooltipTextByRoofState(interiorRoofState),
        () => tooltipTextByRoofState(interiorThreeSixtyRoofState)
      );
    }
  );

  public readonly stageViewStateButtonTooltip$ = this.select(
    this.currentView$,
    this.exteriorStageViewStateByScreenMode$,
    this.interiorStageViewStateByScreenMode$,
    this.interiorThreeSixtyStageViewStateByScreenMode$,
    this.buttonTooltipTexts$,
    (
      currentView,
      exteriorStageViewState,
      interiorStageViewState,
      interiorThreeSixtyStageViewState,
      buttonTooltipTexts
    ) => {
      const tooltipTextByStageViewState = (stageViewState: StageViewStateValue): string =>
        stageViewState === StageViewStateValue.Day
          ? buttonTooltipTexts.turnLightingOff
          : buttonTooltipTexts.turnLightingOn;

      return this.viewHandler<string>(
        currentView,
        () => tooltipTextByStageViewState(exteriorStageViewState),
        () => tooltipTextByStageViewState(interiorStageViewState),
        () => tooltipTextByStageViewState(interiorThreeSixtyStageViewState)
      );
    }
  );

  public readonly roofStateIcon$ = this.select(
    this.currentView$,
    this.exteriorRoofStateByScreenMode$,
    this.interiorRoofStateByScreenMode$,
    this.interiorThreeSixtyRoofStateByScreenMode$,
    (currentView, exteriorRoofState, interiorRoofState, interiorThreeSixtyRoofState) => {
      const iconByRoofState = (roofState: RoofStateValue): Icon =>
        roofState === RoofStateValue.Opened ? Icon.Coupe : Icon.Convertible;

      return this.viewHandler<Icon>(
        currentView,
        () => iconByRoofState(exteriorRoofState),
        () => iconByRoofState(interiorRoofState),
        () => iconByRoofState(interiorThreeSixtyRoofState)
      );
    }
  );

  public readonly currentInvertedViewDefinition$: Observable<StageViewDefinition | undefined> = this.select(
    this.stageMetaData$,
    this.invertedView$,
    (stageMetaData, invertedView) => stageMetaData?.views?.[invertedView as string]
  );

  public readonly exteriorThreeSixtyRotationSpeedFactor$ = this.select(
    this.stageConfig$,
    stageConfig => stageConfig?.exterior?.threeSixtyRotationSpeedFactor
  );

  public readonly exteriorThreeSixtyIndex$ = this.select(
    this.state$,
    this.exteriorViewDefinition$.pipe(filterTruthy()),
    this.isExteriorThreeSixtyStageLoaded$,
    (state, exteriorViewDefinition, isThreeSixtyStageLoaded) =>
      isThreeSixtyStageLoaded && state.exteriorThreeSixtyIndex >= 0
        ? state.exteriorThreeSixtyIndex || 0
        : exteriorViewDefinition?.perspectives?.findIndex(
            perspective => perspective === exteriorViewDefinition?.initialModeConfig?.perspective
          ) || 0
  );

  public readonly currentVehicleExteriorImageUrl$: Observable<string> = this.select(
    this.exteriorImageParameters$,
    this.exteriorThreeSixtyIndex$,
    this.exteriorViewDefinition$,
    (imageParameters, exteriorThreeSixtyIndex, exteriorViewDefinition) =>
      this.createImgSrc(
        imageParameters.cosyId,
        imageParameters.hasImageError,
        imageParameters.baseInfo,
        imageParameters.imgType,
        imageParameters?.perspectives[exteriorThreeSixtyIndex],
        imageParameters.stageViewState,
        imageParameters.roofState,
        exteriorViewDefinition?.fullScreenDefinition?.additionalParameters, // as we want to have the image with the background from fullscreen mode
        imageParameters.imageWidth
      )
  );

  public readonly stageViewTrackingData$ = this.select(this.processedRouteState$, processedRouteState =>
    this.createTrackingData(processedRouteState, TrackingId.StageViewId)
  );

  public readonly interiorThreeSixtyStateTrackingData$ = this.select(this.processedRouteState$, processedRouteState =>
    this.createTrackingData(processedRouteState, TrackingId.ThreeSixtyToggleId)
  );

  public readonly stageViewStateTrackingData$ = this.select(this.processedRouteState$, processedRouteState =>
    this.createTrackingData(processedRouteState, TrackingId.StageViewStateId)
  );

  public readonly roofStateTrackingData$ = this.select(this.processedRouteState$, processedRouteState =>
    this.createTrackingData(processedRouteState, TrackingId.RoofStateId)
  );

  public readonly fullscreenModeTrackingData$ = this.select(this.processedRouteState$, processedRouteState =>
    this.createTrackingData(processedRouteState, TrackingId.FullscreenModeId)
  );

  public readonly screenMirrorTrackingData$ = this.select(this.processedRouteState$, processedRouteState =>
    this.createTrackingData(processedRouteState, TrackingId.ScreenMirrorId)
  );

  public readonly renderThreeSixtyViewer = this.effect(trigger$ =>
    trigger$.pipe(
      switchMap(() => this.isInteriorThreeSixtyView$),
      concatLatestFrom(() => this.pannellumViewer$),
      tap(([isInteriorThreeSixtyView, pannellumViewer]) => {
        // cleanup potentially existing pannellum viewer to prevent multiple instances
        this.updatePannellumViewer(this.pannellumCleanup(isInteriorThreeSixtyView, pannellumViewer));
      }),
      filterTruthy(),
      switchMap(() =>
        combineLatest([
          this.interiorThreeSixtyTextureUrls$,
          this.pannellumViewer$,
          this.stageRatio$,
          from(this.getInteriorThreeSixtyContainer()),
          // three sixty container can update size (shortly after init), thus needs to (re)trigger height calculation
          from(this.getInteriorThreeSixtyContainer()).pipe(switchMap(container => observeOnResize(container)))
        ])
      ),
      filter(([urls]) => urls.length === AMOUNT_OF_INTERIOR_THREE_SIXTY_IMAGES),
      tap(([, pannellumViewer, stageRatio, container]) => {
        // adjust 360 interior height even with same images instead of new installation
        const updateInteriorThreeSixtyContainerHeight = (theContainer: HTMLElement, ratio: StageRatio): void => {
          theContainer.style.height = `${theContainer.getBoundingClientRect().width / ratio}px`;
        };
        updateInteriorThreeSixtyContainerHeight(container, stageRatio);
        // if viewer exists, inform pannellum about the resize
        if (pannellumViewer) {
          pannellumViewer.resize();
        }
      }),
      distinctUntilChanged(
        // stop as long the images are the same and we have an active pannellumViewer
        (prev, current) => JSON.stringify(prev[0][0]) === JSON.stringify(current[0][0]) && !!current[1]
      ),
      concatLatestFrom(() => this.interiorThreeSixtyLastState$),
      tap(([[urls, pannellumViewer, , container], interiorThreeSixtyLastState]) => {
        // create new pannellum viewer or add a new scene to the existing one
        this.updatePannellumViewer(
          this.pannellumViewerSetup(urls, container, interiorThreeSixtyLastState, pannellumViewer)
        );
      })
    )
  );

  public readonly stageExteriorThreeSixtyInteractionTrackingData$ = this.select(
    this.processedRouteState$,
    processedRouteState => this.createTrackingData(processedRouteState, TrackingId.ExteriorThreeSixtyInteractionId)
  );

  public readonly stageInteriorThreeSixtyInteractionTrackingData$ = this.select(
    this.processedRouteState$,
    processedRouteState => this.createTrackingData(processedRouteState, TrackingId.InteriorThreeSixtyInteractionId)
  );

  public readonly trunkButtonTrackingData$ = this.select(this.processedRouteState$, processedRouteState =>
    this.createTrackingData(processedRouteState, TrackingId.GoToTrunkId)
  );

  public readonly onExteriorThreeSixtyStageLoadedChange = this.effect(
    (isExteriorThreeSixtyStageLoaded$: Observable<boolean>) =>
      isExteriorThreeSixtyStageLoaded$.pipe(
        tap(isExteriorThreeSixtyStageLoaded => {
          this.updateExteriorThreeSixtyStageLoaded(!!isExteriorThreeSixtyStageLoaded);
        })
      )
  );

  public readonly onExteriorThreeSixtyIndexChange = this.effect((index$: Observable<number>) => {
    const getRotationDirection = (
      targetIndex: number,
      currentIndex: number,
      perspectives: number
    ): RotationDirection => {
      if ((targetIndex === perspectives - 1 && currentIndex === 0) || targetIndex < currentIndex) {
        return RotationDirection.Clockwise;
      }
      if ((targetIndex === 0 && currentIndex === perspectives - 1) || targetIndex > currentIndex) {
        return RotationDirection.Counterclockwise;
      }
      // fallback which should not being called
      return RotationDirection.Clockwise;
    };

    return index$.pipe(
      filter(targetIndex => targetIndex !== undefined && !Number.isNaN(targetIndex)),
      switchMap(targetIndex =>
        this.exteriorThreeSixtyIndex$.pipe(
          first(),
          map(currentIndex => [targetIndex, currentIndex])
        )
      ),
      filter(([targetIndex, currentIndex]: [number, number]) => targetIndex !== currentIndex),
      tap(([targetIndex]: [number, number]) => {
        this.updateExteriorThreeSixtyIndex(targetIndex);
      }),
      switchMap(([targetIndex, currentIndex]: [number, number]) =>
        this.exteriorPerspectives$.pipe(
          first(),
          map(exteriorPerpectives => [targetIndex, currentIndex, exteriorPerpectives.length])
        )
      ),
      tap(([targetIndex, currentIndex, numberOfExteriorPerpectives]: [number, number, number]) => {
        const rotationDirection = getRotationDirection(targetIndex, currentIndex, numberOfExteriorPerpectives);
        imagePreloadScheduler
          .scheduleForInteractiveRotation(targetIndex, rotationDirection, numberOfExteriorPerpectives, async index =>
            firstValueFrom(this.createExteriorImageUrl(index))
          )
          .catch(noop);
      })
    );
  });

  /**
   * Registers some shortcuts for fullscreen mode to easier interact with the stage (like roof open / close and toggle view state)
   */
  public readonly registerFullscreenShortcuts = this.effect((element$: Observable<HTMLElement>) =>
    element$.pipe(
      switchMap(element => combineLatest([of(element), fromEvent(element, 'keyup')])),
      concatLatestFrom(() => this.isInFullscreenMode$),
      filter(([, isInFullscreenMode]: [[HTMLElement, KeyboardEvent], boolean]) => isInFullscreenMode),
      tap(([[element, event]]: [[HTMLElement, KeyboardEvent], boolean]) => {
        if ((event.code as KeyCode) === KeyCode.KeyL) {
          this.toggleStageViewState();
        }
        if ((event.code as KeyCode) === KeyCode.KeyR) {
          this.toggleRoofState();
        }
        if ((event.code as KeyCode) === KeyCode.KeyV) {
          this.toggleView();
        }
        if ((event.code as KeyCode) === KeyCode.KeyF) {
          this.toggleFullscreen(element);
        }
      })
    )
  );

  /**
   * updates the interior slider index - debounced (as the wb slider component has got issues).
   */
  public readonly updateInteriorSliderIndexDebounced = this.effect((interiorSliderIndex$: Observable<number>) =>
    interiorSliderIndex$.pipe(
      // TODO: investigate if this hardcoded delay is really/still necessary
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      debounceTime(300),
      tap<number>(interiorSliderIndex => {
        this.updateInteriorSliderIndex(interiorSliderIndex);
      })
    )
  );

  /**
   * @returns e.g. `scale(1.15)` to makes something like this possible: [style.transform]="scale(1.15)". Only applies for non fullscreen mode.
   */
  public readonly exteriorTransformStyle$ = this.select(
    this.stageConfig$,
    this.isInFullscreenMode$,
    (stageConfig, isInFullscreenMode) => {
      if (isInFullscreenMode) {
        return ''; // no scale if in fullscreen mode
      }
      const scaleFactor = stageConfig?.exterior?.scaleFactor;
      return scaleFactor ? `scale(${scaleFactor})` : '';
    }
  );

  /**
   * @returns e.g. `translate(-50%, -50%)` or - if there is a scale factor - `translate(-50%, -50%) scale(1.15)`
   */
  public readonly exteriorViewThreeSixtyIndicatorTransformStyle$ = this.select(this.stageConfig$, stageConfig => {
    const scaleFactor = stageConfig?.exterior?.scaleFactor;
    const translateStyle = 'translate(-50%, -50%)';
    return scaleFactor ? `${translateStyle} scale(${scaleFactor})` : translateStyle;
  });

  /**
   * Toggles roof state (opened / closed) for both exterior and interior - if possible (in terms of available)
   */
  public readonly toggleRoofState = this.effect(trigger$ => {
    const createStatePerScreenMode = (
      toggleOffered: StatePerScreenMode<boolean>,
      currentState: StatePerScreenMode<RoofStateValue>
    ): StatePerScreenMode<RoofStateValue> => {
      const toggle = (state: RoofStateValue): RoofStateValue =>
        state === RoofStateValue.Opened ? RoofStateValue.Closed : RoofStateValue.Opened;

      const getRoofState = (screenMode: ScreenMode, roofState: RoofStateValue): RoofStateValue =>
        toggleOffered?.getStateByScreenMode(screenMode) ? toggle(roofState) : roofState;

      return new StatePerScreenMode(
        getRoofState(ScreenMode.NonFullscreen, currentState.nonFullscreen),
        getRoofState(ScreenMode.Fullscreen, currentState.fullscreen)
      );
    };

    return trigger$.pipe(
      concatLatestFrom(() => [
        this.exteriorRoofState$,
        this.interiorRoofState$,
        this.interiorThreeSixtyRoofState$,
        this.exteriorRoofStateToggleOffered$,
        this.interiorRoofStateToggleOffered$,
        this.interiorThreeSixtyRoofStateToggleOffered$,
        this.currentView$,
        this.isInFullscreenMode$
      ]),
      map(
        ([
          ,
          exteriorRoofState,
          interiorRoofState,
          interiorThreeSixtyRoofState,
          exteriorRoofStateToggleOffered,
          interiorRoofStateToggleOffered,
          interiorThreeSixtyRoofStateToggleOffered,
          currentView,
          isInFullscreenMode
        ]) => ({
          exteriorRoofState: createStatePerScreenMode(exteriorRoofStateToggleOffered, exteriorRoofState),
          interiorRoofState: createStatePerScreenMode(interiorRoofStateToggleOffered, interiorRoofState),
          interiorThreeSixtyRoofState: createStatePerScreenMode(
            interiorThreeSixtyRoofStateToggleOffered,
            interiorThreeSixtyRoofState
          ),
          currentView,
          isInFullscreenMode
        })
      ),
      tap(
        ({
          exteriorRoofState,
          interiorRoofState,
          interiorThreeSixtyRoofState,
          currentView,
          isInFullscreenMode
        }: {
          exteriorRoofState: StatePerScreenMode<RoofStateValue>;
          interiorRoofState: StatePerScreenMode<RoofStateValue>;
          interiorThreeSixtyRoofState: StatePerScreenMode<RoofStateValue>;
          currentView: StageView;
          isInFullscreenMode: boolean;
        }) => {
          this.updateUserRoofStateChoice(
            currentView,
            exteriorRoofState,
            interiorRoofState,
            interiorThreeSixtyRoofState,
            isInFullscreenMode
          );
          this.updateExteriorRoofState(exteriorRoofState);
          this.updateInteriorRoofState(interiorRoofState);
          this.updateInteriorThreeSixtyRoofState(interiorThreeSixtyRoofState);
        }
      )
    );
  });

  public readonly toggleInteriorThreeSixty = this.effect(trigger$ =>
    trigger$.pipe(
      concatLatestFrom(() => [this.isInThreeSixtyInteriorMode$, this.currentView$]),
      tap(([, isInThreeSixtyInteriorMode, currentView]: [void, boolean, StageView]) => {
        this.patchState({
          isInThreeSixtyInteriorMode: !isInThreeSixtyInteriorMode,
          currentView: currentView === StageView.Interior ? StageView.Interior360 : StageView.Interior
        });
      })
    )
  );

  /**
   * Toggles the view (exterior / interior)
   */
  public readonly toggleView = this.effect(trigger$ =>
    trigger$.pipe(
      concatLatestFrom(() => this.invertedView$),
      tap(([, invertedView]: [void, StageView]) => {
        this.patchState({ currentView: invertedView });
      })
    )
  );

  /**
   * Toggles stage view state (day / night) for both exterior and interior - if possible (in terms of available)
   */
  public readonly toggleStageViewState = this.effect(trigger$ =>
    trigger$.pipe(
      concatLatestFrom(() => [
        this.exteriorStageViewState$,
        this.interiorStageViewState$,
        this.interiorThreeSixtyStageViewState$,
        this.exteriorStageViewStateToggleOffered$,
        this.interiorStageViewStateToggleOffered$,
        this.interiorThreeSixtyStageViewStateToggleOffered$
      ]),
      map(
        ([
          ,
          exteriorStageViewState,
          interiorStageViewState,
          interiorThreeSixtyStageViewState,
          exteriorStageViewStateToggleOffered,
          interiorStageViewStateToggleOffered,
          interiorThreeSixtyStageViewStateToggleOffered
        ]) => ({
          exteriorStageViewState: this.createStatePerScreenMode(
            exteriorStageViewStateToggleOffered,
            exteriorStageViewState
          ),
          interiorStageViewState: this.createStatePerScreenMode(
            interiorStageViewStateToggleOffered,
            interiorStageViewState
          ),
          interiorThreeSixtyStageViewState: this.createStatePerScreenMode(
            interiorThreeSixtyStageViewStateToggleOffered,
            interiorThreeSixtyStageViewState
          )
        })
      ),
      tap(
        ({
          exteriorStageViewState,
          interiorStageViewState,
          interiorThreeSixtyStageViewState
        }: {
          exteriorStageViewState: StatePerScreenMode<StageViewStateValue>;
          interiorStageViewState: StatePerScreenMode<StageViewStateValue>;
          interiorThreeSixtyStageViewState: StatePerScreenMode<StageViewStateValue>;
        }) => {
          this.updateExteriorStageViewState(exteriorStageViewState);
          this.updateInteriorStageViewState(interiorStageViewState);
          this.updateInteriorThreeSixtyStageViewState(interiorThreeSixtyStageViewState);
        }
      )
    )
  );

  public readonly exteriorImages$ = this.select(
    this.exteriorImageParameters$,
    exteriorImageParameters => exteriorImageParameters
  ).pipe(
    switchMap((imageParameters: ImageParameters) =>
      from(imageParameters?.perspectives || []).pipe(
        map(perspective => this.createExteriorImageConfigItem(imageParameters, perspective)),
        toArray(),
        withLatestFrom(this.exteriorThreeSixtyIndex$),
        tap(([imageConfigs, exteriorThreeSixtyIndex]) => {
          imagePreloadScheduler
            .scheduleForInit(exteriorThreeSixtyIndex, imageConfigs?.length || 0, async index =>
              firstValueFrom(this.createExteriorImageUrl(index))
            )
            .catch(noop);
        }),
        map(([imageConfigs]) => imageConfigs)
      )
    ),
    // allows all subscribers to share the result and replays the last emitted value to new subscribers
    shareReplay(1)
  );

  public readonly interiorImages$ = this.select(
    this.stageBaseData$,
    this.baseInfo$,
    this.interiorPerspectives$,
    this.interiorViewDefinition$,
    this.interiorStageViewStateByScreenMode$,
    this.interiorRoofStateByScreenMode$,
    this.imageWidthByMq$,
    (
      stageBaseData,
      baseInfo,
      interiorPerspectives,
      interiorViewDefinition,
      interiorStageViewState,
      interiorRoofState,
      imageWidth
    ) => {
      const imgType = this.getImageType(interiorViewDefinition?.imageTypes);

      return interiorPerspectives?.reduce<string[]>((arr: string[], perspective: string) => {
        const urlBuilder = stageBaseData.hasImageError
          ? new BbdUrlBuilder(baseInfo.fallbackImageUrl)
          : this.createImgUrlBuilder(
              baseInfo.baseUrl,
              stageBaseData.cosyId,
              imgType,
              perspective,
              interiorStageViewState,
              interiorRoofState,
              interiorViewDefinition.additionalParameters
            );
        const src = urlBuilder.appendImgWidth(imageWidth.toString()).toString();
        return [...arr, src];
      }, []);
    }
  );

  public readonly stageViewTogglePreviewImage$ = this.select(
    this.cosyId$,
    this.baseInfo$,
    this.currentInvertedViewDefinition$,
    (cosyId, baseInfo, currentInvertedViewDefinition) => {
      const imgType = this.getImageType(currentInvertedViewDefinition?.imageTypes);

      return new BbdUrlBuilder(baseInfo?.baseUrl)
        .appendCosyId(cosyId)
        .appendImgType(imgType)
        .appendImgWidth(`${VIEW_TOGGLE_IMG_WIDTH}`)
        .appendGeneric(stageParamsToQueryParams(currentInvertedViewDefinition?.previewImageParameters))
        .toString();
    }
  );

  public readonly hasAnyInteriorView$ = this.select(
    this.hasInteriorView$,
    this.hasInteriorThreeSixtyView$,
    (hasInteriorView, hasInteriorThreeSixtyView) => hasInteriorView || hasInteriorThreeSixtyView
  );

  public readonly displayStageViewToggle$ = this.select(
    this.isAnyInteriorView$,
    this.hasInteriorView$,
    this.hasAnyInteriorView$,
    (isAnyInteriorView, hasInteriorView, hasAnyInteriorView) => {
      if (isAnyInteriorView) {
        // offer toggle to change from interior / interior 360 to exterior
        return true;
      }
      // here for sure it's in exterior view

      if (!hasInteriorView) {
        // there is no preview image (as this is part of the interior view), thus we dont show the button
        return false;
      }

      // and we only want to show the toggle if at least one interior view is available
      return hasAnyInteriorView;
    }
  );

  public readonly updateStageBaseData = this.effect((stageBaseData$: Observable<StageBaseData>) => {
    const update = this.updater(
      // eslint-disable-next-line complexity
      (state, stageBaseData: StageBaseData): AwesomeStageState => {
        const exteriorViewDefinition = this.getExteriorViewDefinition(stageBaseData);
        const interiorViewDefinition = this.getInteriorViewDefinition(stageBaseData);
        const interiorThreeSixtyViewDefinition = this.getInteriorThreeSixtyViewDefinition(stageBaseData);

        const {
          exteriorStageViewState,
          interiorStageViewState,
          interiorThreeSixtyStageViewState,
          currentView,
          exteriorRoofState,
          interiorRoofState,
          interiorThreeSixtyRoofState,
          isInThreeSixtyInteriorMode
        } = state;

        return {
          ...state,
          stageBaseData,

          currentView: stageBaseData.enforceReset
            ? stageBaseData.metaData?.baseInfo.initialStageView
            : currentView || stageBaseData.metaData?.baseInfo.initialStageView,

          exteriorStageViewState: new StatePerScreenMode<StageViewStateValue>(
            this.determineStageViewState(exteriorStageViewState?.nonFullscreen, exteriorViewDefinition),
            this.determineStageViewState(exteriorStageViewState?.fullscreen, exteriorViewDefinition)
          ),
          interiorStageViewState: new StatePerScreenMode<StageViewStateValue>(
            this.determineStageViewState(interiorStageViewState?.nonFullscreen, interiorViewDefinition),
            this.determineStageViewState(interiorStageViewState?.fullscreen, interiorViewDefinition)
          ),
          interiorThreeSixtyStageViewState: new StatePerScreenMode<StageViewStateValue>(
            this.determineStageViewState(
              interiorThreeSixtyStageViewState?.nonFullscreen,
              interiorThreeSixtyViewDefinition
            ),
            this.determineStageViewState(interiorThreeSixtyStageViewState?.fullscreen, interiorThreeSixtyViewDefinition)
          ),

          // for roof state (exterior and interior): no default (respectively undefined) on purpose since
          // most vehicles don't have the option to change roof state
          exteriorRoofState: new StatePerScreenMode<RoofStateValue>(
            this.determineRoofState(exteriorRoofState?.nonFullscreen, exteriorViewDefinition),
            this.determineRoofState(exteriorRoofState?.fullscreen, exteriorViewDefinition)
          ),
          interiorRoofState: new StatePerScreenMode<RoofStateValue>(
            this.determineRoofState(interiorRoofState?.nonFullscreen, interiorViewDefinition),
            this.determineRoofState(interiorRoofState?.fullscreen, interiorViewDefinition)
          ),
          interiorThreeSixtyRoofState: new StatePerScreenMode<RoofStateValue>(
            this.determineRoofState(interiorThreeSixtyRoofState?.nonFullscreen, interiorThreeSixtyViewDefinition),
            this.determineRoofState(interiorThreeSixtyRoofState?.fullscreen, interiorThreeSixtyViewDefinition)
          ),

          isInThreeSixtyInteriorMode:
            isInThreeSixtyInteriorMode || !!stageBaseData?.metaData?.views?.[StageView.Interior360]
        };
      }
    );

    return stageBaseData$.pipe(
      // updating same base data in quick succession can lead to car rotation hopping, that's why we first deep compare before we update.
      distinctUntilChanged((prev, current) => JSON.stringify(prev) === JSON.stringify(current)),
      tap(stageBaseData => update(stageBaseData)),
      concatLatestFrom(() => [
        this.exteriorThreeSixtyIndex$,
        this.interiorSliderIndex$,
        this.exteriorPerspectives$,
        this.interiorPerspectives$
      ]),
      map(
        ([
          stageBaseData,
          exteriorThreeSixtyIndex,
          interiorSliderIndex,
          exteriorPerspectives,
          interiorPerspectives
        ]) => ({
          exteriorIndex: this.calcExteriorIndex(
            stageBaseData.enforceReset,
            exteriorPerspectives,
            exteriorThreeSixtyIndex,
            stageBaseData?.metaData?.views?.[StageView.Exterior360]?.initialModeConfig.perspective
          ),
          interiorIndex:
            interiorSliderIndex ||
            this.calcInteriorSliderIndex(
              interiorPerspectives,
              stageBaseData?.metaData?.views?.[StageView.Interior]?.initialModeConfig.perspective
            )
        })
      ),
      tap(({ exteriorIndex, interiorIndex }: { exteriorIndex: number; interiorIndex: number }) => {
        this.updateExteriorThreeSixtyIndexAccordingToConfig(exteriorIndex);
        this.updateInteriorSliderIndex(interiorIndex);
        // Note: nothing to update for interior 360 yet. for 360 there is no index, but we could map a perspective to a position
      })
    );
  });

  /**
   * Updates the exterior three sixty index - either directly or smoothly - depending on the configuration.
   * Smooth roration might (pre)load more images.
   */
  public readonly updateExteriorThreeSixtyIndexAccordingToConfig = this.effect(
    (exteriorThreeSixtyIndex$: Observable<number>) =>
      exteriorThreeSixtyIndex$.pipe(
        concatLatestFrom(() => this.stageConfig$),
        tap(([index, stageConfig]: [number, StageConfig]) => {
          if (stageConfig.exterior.hasSmoothRotation) {
            this.updateExteriorThreeSixtyIndexSmoothly(index);
          } else {
            this.updateExteriorThreeSixtyIndex(index);
          }
        })
      )
  );

  public readonly updateExteriorThreeSixtyIndexSmoothly = this.effect(
    (exteriorThreeSixtyIndex$: Observable<number>) => {
      /**
       * Creates a map to derive the rotation slowdowns (by index).
       * Deriving from this map it would e.g. create values like ..., 25, 25, 25, 40, 55, 70, 85 (in ms) for a rotation slowdown.
       */
      const createAnimationSlowdownMap = (
        rotationBaseDelay: number,
        rotationSlowdown: number,
        rotationSlowdownReverseIndex: number
      ): AnimationSlowdownMap => {
        const aniMap: AnimationSlowdownMap = { default: rotationBaseDelay };
        for (const index of Array.from({ length: rotationSlowdownReverseIndex }).keys()) {
          aniMap[index] = rotationBaseDelay + (rotationSlowdownReverseIndex - index) * rotationSlowdown;
        }
        return aniMap;
      };

      /**
       * Determines the step delay in milliseconds to slow down the rotation the nearer the target index.
       */
      const determineStepDelay = (
        animationSlowdownMap: AnimationSlowdownMap,
        arrayLength: number,
        arrayIndex: number
      ): Milliseconds => animationSlowdownMap[arrayLength - 1 - arrayIndex] || animationSlowdownMap.default;

      return exteriorThreeSixtyIndex$.pipe(
        concatLatestFrom(() => [
          this.exteriorThreeSixtyIndex$,
          this.exteriorPerspectives$.pipe(map(arr => arr?.length))
        ]),
        switchMap(([targetIndex, currentIndex, numberOfImages]: [number, number, number]) =>
          from(
            imagePreloadScheduler.scheduleForAutomaticRotation(currentIndex, targetIndex, numberOfImages, async index =>
              firstValueFrom(this.createExteriorImageUrl(index))
            )
          )
        ),
        concatLatestFrom(() => this.stageConfig$),
        map(([{ indexRangeArray }, stageConfig]) => [
          indexRangeArray,
          createAnimationSlowdownMap(
            stageConfig?.exterior.rotation.baseDelay,
            stageConfig?.exterior.rotation.rotationSlowdown,
            stageConfig?.exterior.rotation.slowdownReverseIndex
          )
        ]),
        switchMap(([indices, animationSlowdownMap]: [number[], AnimationSlowdownMap]) =>
          from(
            indices.map((intermediateStep: number, arrayIndex: number, indexArray: number[]) => ({
              intermediateStep,
              stepDelay: determineStepDelay(animationSlowdownMap, indexArray.length, arrayIndex)
            }))
          )
        ),
        concatMap(({ intermediateStep, stepDelay }) => of(intermediateStep).pipe(delay(stepDelay))),
        tap<number>(index => {
          this.updateExteriorThreeSixtyIndex(index);
        }),
        concatLatestFrom(() => this.exteriorImages$.pipe(first())),
        tap(([index, exteriorImages]: [number, ImageConfig[]]) => {
          if (exteriorImages[index]) {
            exteriorImages[index].highRes.isLoaded = true;
          }
        })
      );
    }
  );

  public readonly updateStageUpdateData = this.effect((stageUpdateData$: Observable<StageUpdateData | undefined>) => {
    const calcViewRelatedIndex = (
      view: StageView,
      targetPerpective: string,
      exteriorPerspectives: string[],
      interiorPerspectives: string[]
    ): number => {
      if (view === StageView.Exterior360) {
        return this.calcExteriorThreeSixtyIndex(exteriorPerspectives, targetPerpective);
      }
      if (view === StageView.Interior) {
        return this.calcInteriorSliderIndex(interiorPerspectives, targetPerpective);
      }
      if (view === StageView.Interior360) {
        return undefined; // as there is no index
      }
      throw new Error(`no such stage view ${view as string}`);
    };

    const determineIsInThreeSixtyInteriorMode = (view: StageView): boolean | undefined => {
      if (view === StageView.Interior360) {
        return true;
      }
      if (view === StageView.Interior) {
        return false;
      }
      // exterior => intentionally undefined
      return undefined;
    };

    /**
     * verifies the target stage view. target view might be not able to switch to due to missing data
     */
    const verifyTargetStageView = (
      targetView: StageView,
      interiorView: StageViewDefinition,
      interiorThreeSixtyView: StageViewDefinition
    ): StageView => {
      const isValidTargetView =
        (targetView === StageView.Interior && interiorView) ||
        (targetView === StageView.Interior360 && interiorThreeSixtyView);
      return isValidTargetView ? targetView : StageView.Exterior360; // exterior as fallback
    };

    const update = this.updater((state, stageUpdateData: StageUpdateDataExtended): AwesomeStageState => {
      const determineStageViewState = (states: StageViewState[]): StageViewStateValue => {
        const optionalStageViewState = this.getOptionalStageViewState(stageUpdateData.state as StageViewStateValue[]);
        return this.isDayAndNightStageViewStateAvailable(states) && optionalStageViewState;
      };

      const determineRoofState = (states: StageViewState[]): RoofStateValue => {
        // The user behavior when selecting the rooftop state, overrides the default behavior of the preselection of the roof top state
        const optionalRoofState =
          stageUpdateData.dominatedRooftopState || this.getOptionalRoofState(stageUpdateData.state as RoofStateValue[]);
        return this.isOpenedAndClosedRoofStateAvailable(states) && optionalRoofState;
      };

      const stageViewStateOrFallback = (
        stageViewState: StageViewStateValue,
        fallback: StatePerScreenMode<StageViewStateValue>
      ): StatePerScreenMode<StageViewStateValue> =>
        stageViewState ? new StatePerScreenMode<StageViewStateValue>(stageViewState, stageViewState) : fallback;

      const roofStateOrFallback = (
        roofState: RoofStateValue,
        fallback: StatePerScreenMode<RoofStateValue>
      ): StatePerScreenMode<RoofStateValue> =>
        roofState ? new StatePerScreenMode<RoofStateValue>(roofState, roofState) : fallback;

      const { views } = state.stageBaseData.metaData;
      const exteriorView = views[StageView.Exterior360];
      const interiorView = views[StageView.Interior];
      const interiorThreeSixtyView = views[StageView.Interior360];

      const exteriorStageViewState = determineStageViewState(exteriorView?.states);
      const interiorStageViewState = determineStageViewState(interiorView?.states);
      const interiorThreeSixtyStageViewState = determineStageViewState(interiorThreeSixtyView?.states);

      const exteriorRoofState = determineRoofState(exteriorView?.states);
      const interiorRoofState = determineRoofState(interiorView?.states);
      const interiorThreeSixtyRoofState = determineRoofState(interiorThreeSixtyView?.states);

      const targetStageView = stageUpdateData?.view as StageView;
      const currentView = verifyTargetStageView(targetStageView, interiorView, interiorThreeSixtyView);

      return {
        ...state,
        exteriorStageViewState: stageViewStateOrFallback(exteriorStageViewState, state.exteriorStageViewState),
        interiorStageViewState: stageViewStateOrFallback(interiorStageViewState, state.interiorStageViewState),
        interiorThreeSixtyStageViewState: stageViewStateOrFallback(
          interiorThreeSixtyStageViewState,
          state.interiorThreeSixtyStageViewState
        ),
        exteriorRoofState: roofStateOrFallback(exteriorRoofState, state.exteriorRoofState),
        interiorRoofState: roofStateOrFallback(interiorRoofState, state.interiorRoofState),
        interiorThreeSixtyRoofState: roofStateOrFallback(
          interiorThreeSixtyRoofState,
          state.interiorThreeSixtyRoofState
        ),
        currentView,
        isInThreeSixtyInteriorMode: determineIsInThreeSixtyInteriorMode(stageUpdateData.view as StageView)
      };
    });

    return stageUpdateData$.pipe(
      concatLatestFrom(() => [this.store.select(selectIsConfigurationStepCabrioRoof), this.usersChoiceRoofTopState$]),
      map(([stageUpdateData, isCabrioRoofStep, userRooftopChoice]) => {
        const determinateRooftopState = userRooftopChoice && !isCabrioRoofStep ? userRooftopChoice : undefined;

        return {
          ...stageUpdateData,
          dominatedRooftopState: determinateRooftopState
        } as StageUpdateDataExtended;
      }),
      tap((stageUpdateData: StageUpdateDataExtended) => update(stageUpdateData)),
      concatLatestFrom(() => [this.exteriorPerspectives$, this.interiorPerspectives$, this.currentView$]),
      map(
        ([stageUpdateData, exteriorPerspectives, interiorPerspectives, currentView]: [
          StageUpdateData,
          string[],
          string[],
          StageView
        ]) => ({
          view: currentView,
          index: calcViewRelatedIndex(
            currentView,
            stageUpdateData?.perspective,
            exteriorPerspectives,
            interiorPerspectives
          )
        })
      ),
      tap(({ view, index }: { view: StageView; index: number }) => {
        this.viewHandler(
          view,
          () => {
            this.updateExteriorThreeSixtyIndexAccordingToConfig(index);
          },
          () => {
            this.updateInteriorSliderIndex(index);
          },
          () => noop // no index for interior360 (but maybe a position somewhen?)
        );
      })
    );
  });

  public readonly interiorTrunkButtonImageIndex$ = this.select(this.interiorViewDefinition$, interiorViewDefinition =>
    interiorViewDefinition?.perspectives.indexOf(INTERIOR_TRUNK_PERSPECTIVE)
  );

  /**
   * ℹ️ we want to have smooth image sliding. so we cannot just update the index in the store but need to steer via the component.
   * interior slider needs to be available in the DOM / defined first.
   */
  public readonly slideToTrunkImage = this.effect((interiorSlider$: Observable<SliderComponent>) =>
    interiorSlider$.pipe(
      concatLatestFrom(() => [this.interiorTrunkButtonImageIndex$, this.interiorImages$]),
      switchMap(([interiorSlider, interiorTrunkButtonImageIndex, interiorImages]) =>
        combineLatest([
          of(interiorSlider),
          of(interiorTrunkButtonImageIndex),
          // preload all available interior images (trunk image is always the last one)
          from(interiorImagePreloader.add('interiorImages', interiorImages))
        ])
      ),
      tap(([interiorSlider, interiorTrunkButtonImageIndex]: [SliderComponent, number, void]) => {
        interiorSlider.scrollToIndex(interiorTrunkButtonImageIndex).catch(noop);
      })
    )
  );

  /**
   * Returns to the last configuration step the user was in before entering the summary. If there is no previous step, the user is navigated to motorization.
   */
  public readonly returnToConfiguration = this.effect(trigger$ =>
    trigger$.pipe(
      tap(() => {
        this.store.dispatch(updateIsSummarySidebarShown({ isSummarySidebarShown: false }));
      }),
      concatLatestFrom(() => [
        this.store.pipe(selectFilteredPreviousRouteState),
        this.linkService.getLink(AppRoutePath.Motorization)
      ]),
      map(([, previousRouteState, link]) => {
        const isNotValidReturnPath =
          previousRouteState?.isOnlineCode || previousRouteState?.appRoutePath === AppRoutePath.ErrorPage;
        const url = isNotValidReturnPath ? link : previousRouteState?.path || link;
        this.router
          .navigate([url], {
            queryParamsHandling: 'preserve'
          })
          .catch(noop);
      })
    )
  );

  public readonly showExteriorThreeSixtySpinner$ = this.select(
    this.isInFullscreenMode$,
    this.hasImageError$,
    this.exteriorImages$,
    this.exteriorThreeSixtyIndex$,
    interval(CHECK_EXTERIOR_IMAGE_STATE_INTERVAL), // check regularily the model 360 viewer model (which is not observable but might be updated by the wb component itself)
    (isInFullscreenMode, hasImageError, exteriorImages, exteriorThreeSixtyIndex) => {
      if (isInFullscreenMode || hasImageError) {
        return false;
      }

      return (exteriorImages && !exteriorImages[exteriorThreeSixtyIndex]?.highRes?.isLoaded) || false;
    }
  ).pipe(
    debounce(value => (value === true ? timer(IMAGE_LOADER_SPINNER_DEBOUNCE) : timer(0))), // debounce to prevent flickering (debounce only if value is not false!)
    distinctUntilChanged()
  );

  public readonly showInteriorThreeSixtySpinner$: Observable<boolean> = this.select(
    this.state$,
    this.isInFullscreenMode$,
    (state, isInFullscreenMode) => !isInFullscreenMode && state.isInteriorThreeSixtyLoading
  );

  /**
   * @returns (observable of) false if there is no interior view definition or no trunk image
   */
  public readonly hasInteriorTrunkImage$ = this.select(
    this.interiorViewDefinition$,
    interiorViewDefinition => interiorViewDefinition?.perspectives.includes(INTERIOR_TRUNK_PERSPECTIVE) || false
  );

  public readonly displayTrunkButtonOffered$ = this.select(
    this.isAnyInteriorView$,
    this.hasInteriorTrunkImage$,
    (isAnyInteriorView, hasInteriorTrunkImage) => isAnyInteriorView && hasInteriorTrunkImage
  );

  public readonly displayTrunkButtonEnabled$ = this.select(
    this.interiorSliderIndex$,
    this.interiorTrunkButtonImageIndex$,
    this.isInteriorView$,
    (interiorSliderIndex, interiorTrunkButtonImageIndex, isInteriorView) => {
      if (!isInteriorView) {
        return true;
      }
      return interiorSliderIndex !== interiorTrunkButtonImageIndex;
    }
  );

  public readonly hasInteriorThreeSixtyBeenUsed$ = this.select(
    this.state$,
    state => state.hasInteriorThreeSixtyBeenUsed
  ).pipe(filterTruthy());

  public readonly showInteriorThreeSixtyOverlay$ = this.select(
    this.state$,
    this.currentView$,
    (state, currentView) =>
      currentView === StageView.Interior360 &&
      !state.hasInteriorThreeSixtyBeenUsed &&
      state.isInteriorThreeSixtyOverlayEnabled
  );

  public constructor(
    protected override readonly store: Store,
    @Inject(DOCUMENT) protected override readonly document: Document,
    private readonly appDomContext: AppDomContextService,
    private readonly linkService: LinkService,
    private readonly router: Router
  ) {
    super(store, document);

    this.observeFullscreenModeToUpdateState();
    this.renderThreeSixtyViewer();
    this.evaluateFullscreenSupportForPlatform();
  }

  public readonly updateUserRoofStateChoice = (
    currentView: StageView,
    exteriorRoofState: StatePerScreenMode<RoofStateValue>,
    interiorRoofState: StatePerScreenMode<RoofStateValue>,
    interiorThreeSixtyRoofState: StatePerScreenMode<RoofStateValue>,
    isInFullscreenMode: boolean
  ): void => {
    // Find out the current view to get the current roof top status from it.
    const roofStates = {
      [StageView.Interior]: interiorRoofState,
      [StageView.Interior360]: interiorThreeSixtyRoofState,
      [StageView.Exterior360]: exteriorRoofState
    };

    const currentRoofStateView = roofStates[currentView];

    const newRoofStateByUser = isInFullscreenMode
      ? currentRoofStateView?.fullscreen
      : currentRoofStateView?.nonFullscreen;

    // Update the rooftop state chosen by the user. Save for reuse when the user navigates to a new category
    this.patchState({ usersChoiceRoofTopState: newRoofStateByUser });
  };

  private handleInteriorThreeSixtyError(): void {
    this.switchToInteriorView();
    this.updateIsInteriorThreeSixtyError(true);
  }

  private createExteriorImageConfigItem(imageParameters: ImageParameters, perspective: string): ImageConfig {
    return {
      // ℹ️ we intentionally do NOT set lowRes images at all, we only want to always have highRes images
      highRes: {
        src: this.createImgSrc(
          imageParameters.cosyId,
          imageParameters.hasImageError,
          imageParameters.baseInfo,
          imageParameters.imgType,
          perspective,
          imageParameters.stageViewState,
          imageParameters.roofState,
          imageParameters.additionalParameters,
          imageParameters.imageWidth
        ),
        // we intentionally set all image to loaded (altough they are not).
        // this actually prevents flickering.
        // we (pre)load images outside of the component already
        // if we preload outside and we don't set this to true, the component thinks it is not yet loaded,
        // does another request, reads the image from cache quite fast, but we still have the flicker.
        // ℹ️ with having this set to true this might cause issues once we want to get the loading state of the component (which is not available yet at all)
        // if the general "true" for all images does not work we have to update this flag once we have this loaded outside of the component.
        isLoaded: true
      }
    };
  }

  private createExteriorImageUrl(index: number): Observable<string> {
    return this.exteriorImageParameters$.pipe(
      map((imageParameters: ImageParameters): string => {
        const perspective = imageParameters?.perspectives?.[index || 0] || StagePerspective.BE000;
        return this.createImgSrc(
          imageParameters.cosyId,
          imageParameters.hasImageError,
          imageParameters.baseInfo,
          imageParameters.imgType,
          perspective,
          imageParameters.stageViewState,
          imageParameters.roofState,
          imageParameters.additionalParameters,
          imageParameters.imageWidth
        );
      }),
      take(1)
    );
  }

  private viewHandler<T = void>(
    view: StageView,
    onExteriorView: () => T,
    onInteriorView: () => T,
    onInteriorThreeSixtyView: () => T,
    fallback?: () => T
  ): T {
    if (view === StageView.Exterior360) {
      return onExteriorView();
    }
    if (view === StageView.Interior) {
      return onInteriorView();
    }
    if (view === StageView.Interior360) {
      return onInteriorThreeSixtyView();
    }

    if (fallback) {
      return fallback();
    }
    // fallback which should not be called
    return undefined;
  }

  private createTrackingData(routeState: string, label: string): TrackingInput {
    return {
      routeState,
      clickData: {
        category: TrackingCategory.Feature,
        action: TrackingAction.Stage,
        label
      }
    };
  }

  /**
   * Removes unwanted pannellum element from DOM
   */
  private readonly removeElementBySelector = (className: string): void => {
    const element = this.appDomContext.shadowRoot?.querySelector(className);
    element?.remove();
  };

  private readonly getInteriorThreeSixtyContainer = async (): Promise<HTMLElement> =>
    (await waitForElement(
      this.appDomContext.shadowRoot as Document,
      `#${INTERIOR_THREE_SIXTY_CONTAINER_ID}`
    )) as HTMLElement;

  private readonly pannellumOnLoadHandler = (
    viewer: PannellumViewer,
    interiorThreeSixtyLastState: ThreeSixtyInteriorData,
    oldSceneName: string
  ): void => {
    this.updateIsInteriorThreeSixtyLoading(false);
    const panToDefaultPosition = (): void => {
      viewer.setYaw(INTERIOR_THREE_SIXTY.DEFAULT_YAW);
      viewer.setPitch(INTERIOR_THREE_SIXTY.DEFAULT_PITCH);
    };

    // as we don't want to show this on right click (contains text and link to pannellum)
    this.removeElementBySelector(PANNELLUM_CLASS_SELECTOR_ABOUT_MSG);

    // initially we want to pan a bit so that the user is aware of the possibility to drag around
    if (interiorThreeSixtyLastState) {
      viewer.setYaw(interiorThreeSixtyLastState?.yaw);
      viewer.setPitch(interiorThreeSixtyLastState?.pitch);
    } else {
      panToDefaultPosition();
    }

    // Clean up previously added scene with the scene name
    if (oldSceneName) {
      viewer.removeScene(oldSceneName);
    }

    // enable interior 360 overlay after viewer has loaded
    this.patchState({ isInteriorThreeSixtyOverlayEnabled: true });
  };

  // remove pannellum viewer and store last state for later usage
  private readonly pannellumCleanup = (isInteriorThreeSixtyView, viewer): PannellumViewer => {
    if (!isInteriorThreeSixtyView && viewer) {
      this.patchState({
        interiorThreeSixtyLastState: {
          hfov: viewer.getHfov(),
          yaw: viewer.getYaw(),
          pitch: viewer.getPitch()
        }
      });
      viewer = this.pannellumRemove(viewer);
    }
    return viewer;
  };

  private readonly pannellumRemove = (viewer): PannellumViewer => {
    viewer.off();
    viewer.destroy();
    viewer = undefined;

    return viewer;
  };

  private readonly pannellumViewerSetup = (
    urls,
    container,
    interiorThreeSixtyLastState,
    viewer: PannellumViewer
  ): PannellumViewer => {
    const newName = Date.now(); // create unique Name to identify newly added scenes for later removement
    let oldSceneName: string;

    const initialConfig = {
      type: 'cubemap',
      cubeMap: urls,
      autoLoad: true,
      autoRotate: false,
      showControls: false,
      doubleClickZoom: false, // see documentation here: https://github.com/mpetroff/pannellum/blob/master/doc/json-config-parameters.md
      mouseZoom: false, // set to false to make scrolling on mobile possible
      dragConfirm: 'both',
      keyboardZoom: false
    };

    this.updateIsInteriorThreeSixtyLoading(true);

    // MBCC-1091:
    // If the viewer gets a new scene again while a new scene is already loading,
    // this causes a problem inside the pannellum viewer, so we reset the pannellumviewer
    // this happens with low bandwith
    // and on the motorization page, because of multiple imageUrl updates in quick succession
    if (viewer && !viewer.isLoaded()) {
      viewer = this.pannellumRemove(viewer);
    }

    if (viewer) {
      // Add scene when viewer just needs an update
      oldSceneName = viewer.getScene(); // get old scene name to remove it when new scene is loaded

      // add the new Scene with the new images and hand over the current view parameters
      viewer.addScene(newName, {
        ...initialConfig,
        yaw: viewer.getYaw(),
        pitch: viewer.getPitch(),
        hfov: viewer.getHfov()
      });
      viewer.loadScene(newName);
    } else {
      // create viewer
      viewer = pannellum.viewer(container, {
        default: {
          firstScene: 'firstScene'
        },
        scenes: {
          firstScene: {
            ...initialConfig,
            yaw: interiorThreeSixtyLastState?.yaw || 0,
            pitch: interiorThreeSixtyLastState?.pitch || 0,
            hfov: interiorThreeSixtyLastState?.hfov || INTERIOR_THREE_SIXTY.DEFAULT_HFOV
          }
        }
      });

      this.removeElementBySelector(PANNELLUM_CLASS_SELECTOR_LOAD_BOX);

      viewer.on('animatefinished', (updatedInteriorThreeSixtyLastState: ThreeSixtyInteriorData) => {
        // save settings when animation is finished to proceed again with same settings (e.g. if re-entering the component or chaning day/night)
        this.patchState({
          interiorThreeSixtyLastState: {
            yaw: updatedInteriorThreeSixtyLastState?.yaw || 0,
            pitch: updatedInteriorThreeSixtyLastState?.pitch || 0,
            hfov: updatedInteriorThreeSixtyLastState?.hfov || INTERIOR_THREE_SIXTY.DEFAULT_HFOV,
            updatedBy: ThreeSixtyInteriorDataUpdateState.AnimateFinished
          }
        });
      });

      viewer.on('error', () => {
        // on error, switch to regular interior slider view and disable interior 360 button
        this.handleInteriorThreeSixtyError();
      });

      viewer.on('touchstart', () => {
        // When the user touches the overlay on mobile, interior 360 indicator is hidden
        this.patchState({ hasInteriorThreeSixtyBeenUsed: true });
      });

      viewer.on('mousedown', () => {
        // When the user clicks or does a click and drag the interior 360 indicator is hidden
        this.patchState({ hasInteriorThreeSixtyBeenUsed: true });
      });

      viewer.on('mouseup', () => {
        // save settings on mouse up. user might have released the mouse and animation is still ongoing
        // if the user switches to another view during animation is ongoing we at least have the position of the last mouse up.
        this.patchState({
          interiorThreeSixtyLastState: {
            yaw: viewer.getYaw(),
            pitch: viewer.getPitch(),
            hfov: viewer.getHfov(),
            updatedBy: ThreeSixtyInteriorDataUpdateState.MouseUp
          }
        });
      });
    }
    viewer.off('load');
    viewer.on('load', () => {
      this.pannellumOnLoadHandler(viewer, interiorThreeSixtyLastState as ThreeSixtyInteriorData, oldSceneName);
    });
    return viewer;
  };
}
